
/**
 * Bresenham Line Algorithm
 * https://en.wikipedia.org/wiki/Bresenham%27s_line_algorithm
 */
class Bresenham
{
    /**
     * Parse line into sectors
     * @param p1x Point 1 x
     * @param p1y Point 1 x
     * @param p2x Point 2 x
     * @param p2y Point 2 y
     * @param size Size of sector
     */
    public static parse(p1x: number, p1y: number, p2x: number, p2y: number, size: number): number[]
    {
        const sectors = [];
        const grad = (p2y - p1y) / (p2x - p1x);

        const directionX = p1x < p2x ? 1 : -1;
        const directionY = p1y < p2y ? 1 : -1;

        let count = 0;

        sectors.push(p1x, p1y);

        do
        {
            var xOK = Math.floor(p1x / size) == Math.floor(p2x / size);
            var yOK = Math.floor(p1y / size) == Math.floor(p2y / size);

            if (xOK && yOK)
            {
                break;
            }

            let aX = 0;
            let aY = 0;
            aX = Math.round(Math.floor(p1x / size + directionX) * size);

            if (directionX < 0)
            {
                aX = Math.round(Math.ceil((p1x + 1) / size + directionX) * size) - 1;
            }

            aY = Math.round(p1y + (aX - p1x) * grad);

            let b_x = 0;
            let b_y = 0;
            b_y = Math.round(Math.floor(p1y / size + directionY) * size);

            if (directionY < 0)
            {
                b_y = Math.round(Math.ceil((p1y + 1) / size + directionY) * size) - 1;
            }

            b_x = Math.round(p1x + (b_y - p1y) / grad);

            if (Math.pow(aX - p1x, 2) + Math.pow(aY - p1y, 2) < Math.pow(b_x - p1x, 2) + Math.pow(b_y - p1y, 2))
            {
                p1x = aX;
                p1y = aY;
                sectors.push(aX, aY);
            } else
            {
                p1x = b_x;
                p1y = b_y;
                sectors.push(b_x, b_y);
            }
        } while (count++ < 5000);

        return sectors;
    }
}

export default Bresenham;